import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route, UrlSegment, UrlTree } from '@angular/router';

// Auth Services
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { EventService } from '../services/event.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private eventService: EventService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.verifyAccess(state.url);
  }

  private verifyAccess(stateUrl: any) {
    return this.authService.checkUser().pipe(
      map(data => true),
      catchError((err) => {
        // this.eventService.broadcast('open-login-warning');
        this.router.navigate(['/']);
        return throwError(false);
      })
    );
    // const currentUser = this.authService.currentUserValue;
    // if (currentUser) {
    //   // logged in so return true
    //   return true;
    // } else {
    //   // this.router.navigate(['/']);
    //   this.eventService.broadcast('open-login-warning');
    //   return false;
    // }
  }
}
